import React from "react";
import * as Yup from "yup";
import { FcHighPriority, FcPrevious } from "react-icons/fc";
import Select from "react-select";
import { Formik, Form, Field } from "formik";
import { Container, Content } from "./styles";
import { UserType } from "../../types/UserTypes";
import { edit_user } from "../../services/user";
import { UserEditTypes } from "./types";

function UserEdit({ user, afterSubmit, show }: UserEditTypes) {
  const roleOptions = [
    { label: "Administrador", id: 0 },
    { label: "Analista", id: 1 },
    { label: "Digitador", id: 2 },
  ];

  const handleSubmit = async (values: any, { resetForm }: any) => {
    try {
      let edited_user: UserType = values;
      edited_user.id = user.id;

      await edit_user(edited_user);

      resetForm({});
      afterSubmit();
    } catch (error) {
      return error;
    }
  };

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      fontWeight: state.isSelected ? "bold" : "normal",
      color: "black",
      width: "100%",
      height: "100%",
      margin: 0,
      backgroundColor: "white",
      fontSize: "1.2rem",
    }),
    control: (provided: any) => ({
      ...provided,
      border: "2px solid #3751ff",

      borderRadius: "0.5rem",
      height: "100%",
      width: "100%",

      ":focus": {
        border: "2px solid #3751ff",
      },
    }),
    container: (provided: any) => ({
      ...provided,

      height: "100%",
      width: "100%",
    }),
    menu: (provided: any) => ({
      ...provided,
      margin: 4,
    }),
    menuList: (provided: any) => ({
      ...provided,
      padding: 0,
    }),
    singleValue: (provided: any) => ({
      ...provided,
      fontSize: "1.2rem",
      fontWeight: "bold",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontWeight: "500",
      fontSize: "1.2rem",
      color: "black",
    }),
  };

  return (
    <Container>
      <Content>
        <div className="header">
          <FcPrevious className="back-icon" onClick={() => show("hidden")} />
          <p>Editar Informações</p>
        </div>
        <div className="user-identification">
          <div className="infos">
            <div className="info-wrapper">
              <p>Nome:</p>
              <p>{user?.name}</p>
            </div>

            <div className="info-wrapper">
              <p>E-mail:</p>
              <p>{user?.email}</p>
            </div>
          </div>
          <div className="infos">
            <div className="info-wrapper">
              <p>Cargo:</p>
              <p>
                {user?.role === 0
                  ? "Administrador"
                  : user?.role === 1
                  ? "Analista"
                  : "Digitador"}
              </p>
            </div>
          </div>
        </div>

        <Formik
          initialValues={{
            name: user?.name,
            email: user?.email,
            role: user?.role,
          }}
          onSubmit={handleSubmit}
          validationSchema={Yup.object().shape({
            name: Yup.string()
              .min(3, "No mínimo 3 caracteres!")
              .matches(/^[aA-zZ\s]+$/, "O nome só pode conter letras!"),
            email: Yup.string().email("É necessário um e-mail válido!"),
            role: Yup.number(),
          })}
        >
          {(props) => {
            const { values, errors, setFieldValue } = props;

            return (
              <Form>
                <div className="form-wrapper">
                  <div className="inputs-wrapper">
                    <div className={errors.name ? "wrapper-error" : "wrapper"}>
                      <Field
                        name="name"
                        placeholder="Alterar o nome"
                        className={errors.name ? "input-error" : null}
                        value={values.name}
                      />
                      {errors.name ? (
                        <div className="error-wrapper">
                          <FcHighPriority />
                          <p
                            style={{
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {errors.name}
                          </p>
                        </div>
                      ) : null}
                    </div>

                    <div className={errors.email ? "wrapper-error" : "wrapper"}>
                      <Field
                        name="email"
                        placeholder="Alterar o e-mail"
                        className={errors.email ? "input-error" : null}
                        value={values.email}
                      />

                      {errors.email ? (
                        <div className="error-wrapper">
                          <FcHighPriority />
                          <p
                            style={{
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {errors.email}
                          </p>
                        </div>
                      ) : null}
                    </div>

                    <div className="select-content">
                      <p>Cargo</p>
                      <Select
                        placeholder={"Selecione o cargo"}
                        styles={customStyles}
                        options={roleOptions}
                        value={{
                          label:
                            values.role === 0
                              ? "Administrador"
                              : values.role === 1
                              ? "Analista"
                              : "Digitador",
                          id: values.role,
                        }}
                        name="role"
                        id="role"
                        onChange={(option) => setFieldValue("role", option!.id)}
                      />
                    </div>
                  </div>

                  <div className="button-wrapper">
                    <input type="submit" id="submit-button" value="Salvar" />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Content>
    </Container>
  );
}

export default UserEdit;
